import { DataBean } from "../DataBean";

export class CreateTaking extends DataBean {


    public async createPhysicalTakingItem(idPhysicalTaking:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_createPhysicalTakingItem_Number", [idPhysicalTaking]);
    }

    //aqui

 
}